<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title" v-if="isDeleteAction">Confirmação de remoção do produto</h4>
        <h4 class="c-modalCard__title" v-else>Confirmação de remoção do vínculo do anúncio</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <template v-if="isDeleteAction">
        <div class="c-modalCard__body">
          O produto será excluído do PlaceMarket e do Mercado Livre. Esta ação não pode ser desfeita.
        </div>

        <div class="c-modalCard__body">
          Tem certeza de que deseja remover o produto {{ productInText }} do PlaceMarket e do Mercado Livre?
        </div>
      </template>

      <template v-else>
        <div class="c-modalCard__body">
          O produto sai só do PlaceMarket. O anúncio continua no Mercado Livre, sem alteração, e pode ser migrado para o PlaceMarket de novo.
        </div>

        <div class="c-modalCard__body">
          Tem certeza de que deseja remover o vínculo do anúncio {{ productInText }} com o PlaceMarket?
        </div>
      </template>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      product: {
        type: Object,
        required: false
      },
      typeAction: {
        type: String,
        default: 'unlink'
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('confirm', true)
        this.close()
      },
      cancel () {
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    computed: {
      isDeleteAction () {
        return this.typeAction === 'delete'
      },
      productInText () {
        if (this.product === null) {
          return null
        }

        return `'${this.product.title}'` + (this.product.code !== null ? ` (${this.product.code})` : '')
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalProductRemoveConfirmation.vue?54791838